/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import qDocPromise from 'config/qDoc';
import tablePriceGuideDef from '../../tablePriceGuideDef';
import tablePriceGuideServicesDef from '../../tablePriceGuideServicesDef';
import { SelectedOffersContext } from '../../SelectedOffersContext';

import styles from './styles';

class TablePriceGuide extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired, // 'products' or 'services'
    clearTrigger: PropTypes.bool,
    searchString: PropTypes.string.isRequired,
  };

  state = {
    qMatrix: [],
    currency: '',
    // sortColumn: 0, // Column index to sort
    // sortDirection: 'asc', // 'asc' or 'desc'
  };

  componentDidMount() {
    this.createQObject();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clearTrigger !== this.props.clearTrigger) {
      this.setState({}); // Force re-render when clearTrigger changes
    }
  }

  componentWillUnmount() {
    this.destroyQObject();
  }

  createQObject = async () => {
    const qDoc = await qDocPromise;
    const def = this.props.type === 'services' ? tablePriceGuideServicesDef : tablePriceGuideDef;
    this.qObject = await qDoc.createSessionObject(def);
    this.qObject.on('changed', this.updateQMatrix);
    this.updateQMatrix();
  };

  destroyQObject = async () => {
    const qDoc = await qDocPromise;
    qDoc.destroySessionObject(this.qObject.id);
  };

  updateQMatrix = async () => {
    const layout = await this.qObject.getLayout();
    this.setState({ qMatrix: layout.qHyperCube.qDataPages[0].qMatrix, currency: layout.currency });
  };

  handleCheckboxChange = (context, row) => {
    const { addItem, removeItem } = context;
    const sku = row[0] && row[0].qText ? row[0].qText : '';
    const description = row[1] && row[1].qText ? row[1].qText : '';
    const price = this.props.type === 'services' ? (row[3] && row[3].qText ? parseFloat(row[3].qText) : 0) : (row[5] && row[5].qText ? parseFloat(row[5].qText) : 0);
    const type = this.props.type;
    const uniqueKey = `${type}_${sku}_${description}`;

    const isSelected = context.selectedItems.some(
      (item) => `${item.type}_${item.SKU}_${item.Description}` === uniqueKey
    );

    const item = { type, SKU: sku, Description: description, Units: 1, Price: price };

    if (isSelected) {
      removeItem(uniqueKey);
    } else {
      addItem(item);
    }
  };

  // handleSort = (columnIndex) => {
  //   const { sortColumn, sortDirection } = this.state;
  //   let newDirection = 'asc';

  //   if (sortColumn === columnIndex && sortDirection === 'asc') {
  //     newDirection = 'desc';
  //   }

  //   this.setState({
  //     sortColumn: columnIndex,
  //     sortDirection: newDirection,
  //   });
  // };

  handleSort = (columnIndex) => {
    this.props.handleSort(columnIndex);
  };

  // sortData = (data) => {
  //   const { sortColumn, sortDirection } = this.state;
  //   if (sortColumn === null) return data;

  //   const sortedData = [...data].sort((a, b) => {
  //     const valueA = a[sortColumn] && a[sortColumn].qText ? a[sortColumn].qText : '';
  //     const valueB = b[sortColumn] && b[sortColumn].qText ? b[sortColumn].qText : '';

  //     if (!isNaN(valueA) && !isNaN(valueB)) {
  //       return sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
  //     }
  //     return sortDirection === 'asc'
  //       ? valueA.localeCompare(valueB)
  //       : valueB.localeCompare(valueA);
  //   });

  //   return sortedData;
  // };

  sortData = (data) => {
    const { sortColumn, sortDirection } = this.props;
    if (sortColumn === null) return data;
  
    const sortedData = [...data].sort((a, b) => {
      const valueA = a[sortColumn] && a[sortColumn].qText ? a[sortColumn].qText : '';
      const valueB = b[sortColumn] && b[sortColumn].qText ? b[sortColumn].qText : '';
  
      if (!isNaN(valueA) && !isNaN(valueB)) {
        return sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      }
      return sortDirection === 'asc'
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    });
  
    return sortedData;
  };

  renderTable(context) {
    const { classes, type, searchString, isPartner } = this.props;
    // const { qMatrix, currency, sortColumn, sortDirection } = this.state;
    const { qMatrix, currency } = this.state;
    const { selectedItems } = context;

    const sortedMatrix = this.sortData(qMatrix);

    // const skus = filteredQMatrix.map((row) => row[0].qText);

    const skusToHideForPartners = ['Q501010E', 'Q501021E', 'Q501022E', 'Q501031E', 'Q501061E', 'Q501071E', 'Q501081E', 'Q501091E'];

    // old
    // const filteredQMatrix = sortedMatrix.filter(row => row.reduce((arr, col) => [...arr, col.qText], []).some(item => item.toLowerCase().includes(searchString.toLowerCase())));


    const filteredQMatrix = sortedMatrix.filter(row => {
      // Filter out rows with the specified SKUs when isPartner is true
      if (isPartner) {
        const sku = row[0] && row[0].qText ? row[0].qText : '';
        if (skusToHideForPartners.includes(sku)) return false;
      }
      // Continue with search string filtering
      return row
        .reduce((arr, col) => [...arr, col.qText], [])
        .some(item => item.toLowerCase().includes(searchString.toLowerCase()));
    });

    return (
      <div className={classes.container}>
        <div className={classes.tableWrapper}>
          {qMatrix.length === 0 && <div className={classes.noResults}>No results</div>}
          {qMatrix.length > 0 && (
            <table className={classes.table}>
              <thead>
                <tr>
                  <th className={classes.th} />
                  <th
                    className={classes.th}
                    onClick={() => this.handleSort(0)}
                    style={{ cursor: 'pointer' }}
                  >
                    SKU No {this.props.sortColumn === 0 && (this.props.sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th
                    className={classes.th}
                    onClick={() => this.handleSort(1)}
                    style={{ cursor: 'pointer' }}
                  >
                    {type === 'services' ? 'Service' : 'Description'}{' '}
                    {this.props.sortColumn === 1 && (this.props.sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  <th
                    className={classes.th}
                    onClick={() => this.handleSort(2)}
                    style={{ cursor: 'pointer' }}
                  >
                    {type === 'services' ? 'Notes' : 'Unit'}{' '}
                    {this.props.sortColumn === 2 && (this.props.sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  {
                    type==="products" && 
                    <th
                    className={classes.th}
                    onClick={() => this.handleSort(3)}
                    style={{ cursor: 'pointer' }}
                  >
                    Notes
                    {this.props.sortColumn === 3 && (this.props.sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                  }
                  <th
                    className={classes.th}
                    onClick={() => this.handleSort(5)}
                    style={{ textAlign: 'left', paddingRight: '1em', cursor: 'pointer' }}
                  >
                    Price ({currency}) {this.props.sortColumn === 5 && (this.props.sortDirection === 'asc' ? '↑' : '↓')}
                  </th>
                </tr>
              </thead>
              <tbody>
                
                {
                filteredQMatrix.map((row, i) => {
                  const sku = row[0] && row[0].qText ? row[0].qText : '';
                  const description = row[1] && row[1].qText ? row[1].qText : '';
                  const uniqueKey = `${type}_${sku}_${description}`;

                  const isChecked = selectedItems.some(
                    (item) => `${item.type}_${item.SKU}_${item.Description}` === uniqueKey
                  );

                  // return (
                  //   <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#F2F3F7' }}>
                  //     <td className={classes.checkbox}>
                  //       <input
                  //         type="checkbox"
                  //         checked={isChecked}
                  //         onChange={() => this.handleCheckboxChange(context, row)}
                  //       />
                  //     </td>
                  //     {row.map((col, j) => (
                  //       type === "products" && j === 4 ? null : ( // Skip Z-Index column only for products
                  //         <td key={j} className={classes.td}>
                  //           {col.qText === '0' || col.qText === '-1' ? '' : col.qText}
                  //         </td>
                  //       )
                  //     ))}
                  //   </tr>
                  // );


                  return (
                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#F2F3F7' }}>
                      <td className={classes.checkbox}>
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => this.handleCheckboxChange(context, row)}
                        />
                      </td>
                      {row.map((col, j) => {

                        // Check if we're in the Price column and the SKU matches specific values
                        if (type === 'services' && j === 3) {
                          if (['QDACSE', 'QDICSE', 'TLNDCSE'].includes(sku)) {
                            return (
                              <td key={j} className={classes.td}>
                                20% license ACV
                              </td>
                            );
                          }
                        }
              
                        // Skip Z-Index column only for products
                        if (type === 'products' && j === 4) {
                          return null;
                        }
              
                        return (
                          <td key={j} className={classes.td}>
                            {col.qText === '0' || col.qText === '-1' ? '' : col.qText}
                          </td>
                        );
                      })}
                    </tr>
                  );
                  
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className={classes.tableFooter}>
          <p>Number of items: {filteredQMatrix.length}</p>
        </div>
      </div>
    );
  }

  render() {
    return (
      <SelectedOffersContext.Consumer>
        {(context) => this.renderTable(context)}
      </SelectedOffersContext.Consumer>
    );
  }
}

TablePriceGuide.contextType = SelectedOffersContext; // Attach the context

export default injectSheet(styles)(TablePriceGuide);
